// import {
//                         Component,
//                         ViewChild,
//                         OnDestroy,
//                         OnInit,
//                         ChangeDetectorRef,
//                         Injectable
//                       } from '@angular/core';
//                       import { Subscription, Observable, of } from 'rxjs';
//                       import { catchError } from 'rxjs/operators';
//                       import { HttpClient, HttpHeaders } from '@angular/common/http';
//                       import { environment } from 'src/environments/environment'; // Ensure this path is correct
                      
//                       // --- Import Modal Dependencies ---
//                       import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
//                       // Correct path relative to THIS component for the DrilldownModalComponent
//                       // Assuming it's in '../statistics-chart/drilldown-modal/' relative to this file's folder
//                       import { DrilldownModalComponent } from '../statistics-chart/drilldown-modal/drilldown-modal.component';
                      
//                       // Import necessary types from ng-apexcharts
//                       import {
//                         ApexChart,
//                         ApexAxisChartSeries,
//                         ApexDataLabels,
//                         ApexPlotOptions,
//                         ApexYAxis,
//                         ApexLegend,
//                         ApexStroke,
//                         ApexXAxis,
//                         ApexTooltip,
//                         ApexStates,
//                         ApexNonAxisChartSeries,
//                         ApexResponsive,
//                         ChartComponent,
//                         ApexTitleSubtitle
//                       } from 'ng-apexcharts';
                      
//                       // --- Interfaces ---
//                       export interface StatisticData {
//                         campaign_uuid: string;
//                         campaign_name: string;
//                         organization: string;
//                         time_group: string; // Format: "YYYY-MM"
//                         total_minutes: number;
//                       }
                      
//                       export interface ApiResponse {
//                         message: string;
//                         data: StatisticData[];
//                         error: string | null;
//                       }
                      
//                       // --- Service Definition ---
//                       @Injectable({ providedIn: 'root' })
//                       export class StatisticsService {
//                         private apiUrl = `${environment.apiUri}/statistics/organisations`;
//                         constructor(private http: HttpClient) { }
                      
//                         getStatistics(start: string, end: string, groupby: string): Observable<ApiResponse> {
//                             console.log(`Heatmap Proxy Call: Fetching stats from ${start} to ${end} grouped by ${groupby} via ${this.apiUrl}`);
//                             const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Accept': 'application/json' });
//                             const body = { start, end, groupby };
//                             return this.http.post<ApiResponse>(this.apiUrl, body, { headers: headers })
//                                 .pipe(
//                                     catchError(error => {
//                                         console.error('Heatmap Proxy API Error:', error);
//                                         const errorResponse: ApiResponse = {
//                                             message: error.error?.message || 'Failed to fetch heatmap statistics', data: [],
//                                             error: error.error?.error || error.message || 'Unknown proxy error'
//                                         };
//                                         return of(errorResponse);
//                                     })
//                                 );
//                         }
//                       }
                      
//                       // --- ChartOptions Type Definition ---
//                       export type HeatmapChartOptions = {
//                         series: ApexAxisChartSeries | ApexNonAxisChartSeries;
//                         chart: ApexChart;
//                         xaxis: ApexXAxis;
//                         stroke: ApexStroke;
//                         dataLabels: ApexDataLabels;
//                         plotOptions: ApexPlotOptions;
//                         yaxis: ApexYAxis;
//                         tooltip: ApexTooltip;
//                         legend?: ApexLegend;
//                         states?: ApexStates;
//                         responsive?: ApexResponsive[];
//                         title?: ApexTitleSubtitle;
//                       };
                      
//                       // --- Component Definition ---
//                       @Component({
//                         selector: 'app-statistics-heatmap',
//                         templateUrl: './statistics-heatmap.component.html',
//                         styleUrls: ['./statistics-heatmap.component.scss'],
//                       })
//                       export class StatisticsHeatmapComponent implements OnInit, OnDestroy {
                      
//                         // --- Properties for Heatmap Chart ---
//                         @ViewChild('heatmapChart') private heatmapChartComponent!: ChartComponent;
//                         public heatmapOptions!: Partial<HeatmapChartOptions>;
//                         public isLoading: boolean = false;
//                         public errorMessage: string | null = null;
//                         public totalMinutesPerMonth: { [month: string]: number } = {};
                      
//                         // --- Properties for Filters ---
//                         public isCollapsed: boolean = true; // Start collapsed
//                         public allOrganizations: string[] = [];
//                         public selectedOrganizations: { [orgName: string]: boolean } = {};
//                         public initialOrgLoadComplete: boolean = false;
                      
//                         // --- Data Properties ---
//                         private dataSubscription: Subscription | undefined;
//                         // IMPORTANT: Made public for template access
//                         public lastRawData: StatisticData[] = []; // Store raw data for the year
                      
//                         // --- Modal Properties ---
//                         private modalRef: NgbModalRef | undefined;
                      
//                         constructor(
//                             private statisticsService: StatisticsService,
//                             private cdRef: ChangeDetectorRef,
//                             private modalService: NgbModal // Inject NgbModal service
//                         ) {
//                             this.initializeHeatmapOptions();
//                         }
                      
//                         ngOnInit() {
//                             this.loadHeatmapData();
//                         }
                      
//                         ngOnDestroy() {
//                             this.dataSubscription?.unsubscribe();
//                             this.modalRef?.close(); // Close modal if component is destroyed
//                         }
                      
//                         // --- Data Fetching ---
//                         loadHeatmapData() {
//                             const { start, end } = this.calculateDateRangeForYear();
//                             console.log(`🔥 Heatmap: Fetching data for year: ${start} to ${end}`);
//                             this.isLoading = true;
//                             this.errorMessage = null;
//                             this.dataSubscription?.unsubscribe();
                      
//                             this.dataSubscription = this.statisticsService
//                                 .getStatistics(start, end, 'month')
//                                 .subscribe({
//                                     next: (response) => {
//                                         console.log('✅ Heatmap API response received');
//                                         // Set loading false *after* processing potentially needed info
//                                         // this.isLoading = false; // Moved down
                      
//                                         if (response.error) {
//                                             this.errorMessage = response.message || response.error || 'Unknown error from API';
//                                             this.lastRawData = [];
//                                         } else {
//                                             this.errorMessage = null;
//                                             this.lastRawData = response.data || [];
//                                             console.log('📦 Heatmap Data loaded:', this.lastRawData.length);
//                                         }
                      
//                                         // Mark initial load complete and potentially populate filters
//                                         if (!this.initialOrgLoadComplete) {
//                                             if (this.lastRawData.length > 0) {
//                                                 this.populateInitialOrganizations(this.lastRawData);
//                                             } else {
//                                                 this.allOrganizations = [];
//                                                 this.selectedOrganizations = {};
//                                             }
//                                             this.initialOrgLoadComplete = true;
//                                         }
                      
//                                         this.isLoading = false; // Set loading false *before* processing for display
                      
//                                         // Process data AFTER setting loading=false and initialOrgLoadComplete=true
//                                         // Use setTimeout to ensure view updates related to loading/filters are potentially rendered first
//                                         setTimeout(() => {
//                                             this.processAndDisplayHeatmap(this.lastRawData);
//                                             this.cdRef.detectChanges(); // Detect changes after processing
//                                         }, 0);
//                                     },
//                                     error: (err) => {
//                                         console.error('❌ Heatmap HTTP call failed:', err);
//                                         this.errorMessage = 'Failed to connect to the backend service.';
//                                         this.lastRawData = [];
//                                         if (!this.initialOrgLoadComplete) { // Ensure filters are marked loaded even on error
//                                             this.allOrganizations = [];
//                                             this.selectedOrganizations = {};
//                                             this.initialOrgLoadComplete = true;
//                                         }
//                                         this.isLoading = false; // Ensure loading is false
//                                         this.processAndDisplayHeatmap([]); // Process empty data to clear chart
//                                         this.cdRef.detectChanges(); // Update view
//                                     },
//                                     complete: () => {
//                                         console.log('📍 Heatmap Observable complete');
//                                         // isLoading should already be false from 'next' or 'error'
//                                     }
//                                 });
//                         }
                      
//                         // --- Filter Initialization ---
//                         populateInitialOrganizations(data: StatisticData[]) {
//                             const orgSet = new Set<string>(data.map((d) => d.organization));
//                             this.allOrganizations = Array.from(orgSet).sort((a, b) => a.localeCompare(b));
//                             const previousSelection = { ...this.selectedOrganizations };
//                             this.selectedOrganizations = {};
//                             this.allOrganizations.forEach((org) => {
//                                 this.selectedOrganizations[org] = previousSelection[org] ?? true;
//                             });
//                         }
                      
//                         // --- Heatmap Initialization (Includes cursor/click events) ---
//                         initializeHeatmapOptions(): void {
//                             this.heatmapOptions = {
//                                 series: [],
//                                 chart: {
//                                     type: 'heatmap',
//                                     height: 450,
//                                     toolbar: { show: true },
//                                     events: {
//                                         // Click handler for heatmap cells
//                                         dataPointSelection: (event, chartContext, config) => {
//                                             // seriesIndex corresponds to organization row, dataPointIndex to month column
//                                             this.handleHeatmapDataPointClick(config.seriesIndex, config.dataPointIndex, chartContext);
//                                         },
//                                         // Explicit cursor handling for heatmap cells
//                                         dataPointMouseEnter: (event: any) => {
//                                             if (event.target) {
//                                                  (event.target as HTMLElement).style.cursor = 'pointer';
//                                             }
//                                         },
//                                         dataPointMouseLeave: (event: any) => {
//                                             if (event.target) {
//                                                 (event.target as HTMLElement).style.cursor = 'default';
//                                             }
//                                         }
//                                     }
//                                 },
//                                 plotOptions: {
//                                   heatmap: {
//                                       shadeIntensity: 0.6,
//                                       radius: 2,
//                                       useFillColorAsStroke: false,
//                                       enableShades: true,
//                                       colorScale: {
//                                           ranges: [
//                                               { from: 0, to: 0.99, name: '0', color: '#EEEEEE' },   // gray (no activity)
//                                               { from: 1, to: 60, name: '1–60 min', color: '#AED9E0' }, // very light cyan
//                                               { from: 61, to: 300, name: '61–300 min', color: '#75B3FF' }, // bright blue
//                                               { from: 301, to: 1000, name: '301–1k min', color: '#FFC300' }, // bright yellow
//                                               { from: 1001, to: 3000, name: '1k–3k min', color: '#FF6600' }, // intense orange
//                                               { from: 3001, to: 9000, name: '3k–9k min', color: '#FF0000' }, // pure red
//                                               { from: 9001, to: 15000, name: '9k–15k min', color: '#C70039' } // intense dark red
//                                           ],
//                                           inverse: false,
//                                           min: 0
//                                       }
//                                   }
//                               },
                              
                              
//                                 // dataLabels: { enabled: false },
//                                 dataLabels: {
//                                   enabled: true,
//                                   formatter: (val) => {
//                                     const numVal = Number(val);
//                                     return !isNaN(numVal) && numVal > 0 ? Math.round(numVal).toString() : '';
//                                   }
//                                 },
                                
                                
//                                 stroke: { width: 1, colors: ['#FFFFFF'] },
//                                 xaxis: {
//                                     type: 'category',
//                                     position: 'top',
//                                     tooltip: { enabled: false },
//                                     labels: {
//                                       rotate: -45,
//                                       style: {
//                                         fontSize: '11px',
//                                         whiteSpace: 'pre'
//                                       },
//                                       formatter: (value: string) => {
//                                         const total = this.totalMinutesPerMonth?.[value] ?? 0;
//                                         return `${value} ( ${Math.round(total)} min )`;
//                                       }
//                                     } as any
//                                   },                                                            
                                                                 
                                  
//                                 yaxis: { tooltip: { enabled: false }, reversed: false }, 
//                                 tooltip: {
//                                   y: {
//                                       formatter: (value) => `${value ? Math.round(value) : '0'} minut`
//                                   }
//                                 },
//                                 title: { /**/ },
//                                 legend: { show: true, position: 'bottom', horizontalAlign: 'center' },
//                                  responsive: [ // Responsive adjustments
//                                     { breakpoint: 992, options: { chart: { height: 500 } } },
//                                     { breakpoint: 768, options: { chart: { height: 600 }, yaxis: { labels: { minWidth: 80, maxWidth: 100 } } } },
//                                     { breakpoint: 576, options: { chart: { height: 450 }, yaxis: { labels: { show: false } } } }
//                                 ]
//                             };
//                             console.log('🔥 Heatmap options initialized with explicit cursor events.');
//                         }
                      
//                         // --- Heatmap Data Processing ---
//                         processAndDisplayHeatmap(rawData: StatisticData[]) {
//                             console.log('🔥 Processing data for HEATMAP display...');
                        
//                             if (!this.initialOrgLoadComplete) {
//                                 console.log("⏳ Heatmap: Waiting for initial organization load to complete.");
//                                 return; // Don't process until filters are ready
//                             }
                        
//                             const activeOrganizations = Object.entries(this.selectedOrganizations)
//                                 .filter(([, isSelected]) => isSelected)
//                                 .map(([orgName]) => orgName);
                        
//                             const filteredData = rawData.filter(item => activeOrganizations.includes(item.organization));
                        
//                             // Determine months and orgs from *filtered* data
//                             const monthSet = new Set<string>(filteredData.map((d) => d.time_group));
//                             const sortedMonths = Array.from(monthSet).sort();
                        
//                             const orgSet = new Set<string>(filteredData.map(d => d.organization));
//                             const sortedOrgs = Array.from(orgSet).sort((a, b) => a.localeCompare(b));
                        
//                             let heatmapSeries: ApexAxisChartSeries = [];
                        
//                             // Reset monthly totals
//                             this.totalMinutesPerMonth = {};
//                             sortedMonths.forEach(month => this.totalMinutesPerMonth[month] = 0);
                        
//                             if (filteredData.length > 0) {
//                                 const dataMap = new Map<string, Map<string, number>>();
                        
//                                 filteredData.forEach((item) => {
//                                     const org = item.organization;
//                                     const month = item.time_group;
//                                     const minutes = Number(item.total_minutes) || 0;
                        
//                                     if (!dataMap.has(org)) {
//                                         dataMap.set(org, new Map());
//                                     }
                        
//                                     const orgMonthMap = dataMap.get(org)!;
//                                     const current = orgMonthMap.get(month) || 0;
//                                     orgMonthMap.set(month, current + minutes);
                        
//                                     // Accumulate for monthly total
//                                     this.totalMinutesPerMonth[month] += minutes;
//                                 });
                        
//                                 heatmapSeries = sortedOrgs.map(orgName => {
//                                     const orgDataMap = dataMap.get(orgName) || new Map();
//                                     return {
//                                         name: orgName,
//                                         data: sortedMonths.map(month => ({
//                                             x: month,
//                                             y: orgDataMap.get(month) || 0
//                                         }))
//                                     };
//                                 });
                        
//                                 console.log('🔥 Final Heatmap series:', heatmapSeries);
//                                 console.log('📅 Final Heatmap categories (xaxis - months):', sortedMonths);
//                                 console.log('📊 Monthly totals:', this.totalMinutesPerMonth);
//                             } else {
//                                 console.log('🔥 Heatmap: No data after filtering.');
//                             }
                        
//                             this.updateHeatmap(sortedMonths, heatmapSeries);
//                         }
                      
//                         // --- Heatmap Update Function ---
//                         updateHeatmap(monthCategories: string[], series: ApexAxisChartSeries) {
//                             this.heatmapOptions = {
//                                 ...this.heatmapOptions, // Keep existing options (like events!)
//                                 series: series,
//                                 xaxis: {
//                                     ...this.heatmapOptions.xaxis, // Keep existing axis settings
//                                     categories: monthCategories,
//                                 },
//                                 yaxis: { ...this.heatmapOptions.yaxis }, // Keep existing Y-axis settings
//                                 plotOptions: { ...this.heatmapOptions.plotOptions } // Ensure plotOptions persist
//                                 // The y-axis labels will be automatically derived from the series names by ApexCharts
//                             };
//                             // Use the chart instance update method for potentially smoother updates with dynamic data
//                             this.heatmapChartComponent?.updateOptions(this.heatmapOptions).catch(err => console.error("Heatmap update error:", err));
//                             // Fallback or alternative: this.cdRef.detectChanges();
//                             console.log('🔥 Heatmap options updated.');
//                         }
                      
//                         // --- Event Handlers for Filters ---
//                         selectAllOrgs(): void {
//                             if (this.isLoading || !this.allOrganizations) return;
//                             this.allOrganizations.forEach(org => { this.selectedOrganizations[org] = true; });
//                             this.onOrganizationSelectionChange();
//                         }
                      
//                         deselectAllOrgs(): void {
//                             if (this.isLoading || !this.allOrganizations) return;
//                             this.allOrganizations.forEach(org => { this.selectedOrganizations[org] = false; });
//                             this.onOrganizationSelectionChange();
//                         }
                      
//                         onOrganizationSelectionChange(): void {
//                             if (this.isLoading) return;
//                             console.log('👥 Heatmap: Organization selection changed:', this.selectedOrganizations);
//                             this.processAndDisplayHeatmap(this.lastRawData); // Re-process with new selection
//                         }
                      
//                         // --- Click Handler for Heatmap Cells ---
//                         handleHeatmapDataPointClick(seriesIndex: number, dataPointIndex: number, chartContext: any): void {
//                             let selectedOrg: string = '';
//                             let selectedMonth: string = '';
//                             try {
//                                 const w = chartContext.w;
//                                 // Use seriesNames for Y-axis (organization)
//                                 selectedOrg = w.globals.seriesNames[seriesIndex] ?? 'Nieznana organizacja';
//                                  // Use labels for X-axis (month)
//                                 selectedMonth = w.globals.labels[dataPointIndex] ?? 'Nieznany miesiąc';
//                             } catch (e) {
//                                 console.error("Error extracting context from heatmap click:", e);
//                                 this.errorMessage = "Nie można odczytać danych punktu.";
//                                 this.cdRef.detectChanges(); return;
//                             }
                      
//                             console.log(`🖱️ Heatmap Cell Drilldown requested for Org: ${selectedOrg}, Month: ${selectedMonth}`);
//                             this.prepareAndOpenModal(selectedOrg, [selectedMonth], 'month'); // Specify 'month' context
//                         }
                      
//                         // --- Click Handler for Filter Labels ---
//                         handleFilterLabelClick(orgName: string): void {
//                             // We removed the check for this.selectedOrganizations[orgName]
//                             console.log(`🖱️ Heatmap Filter Label Drilldown for Org: ${orgName}`);
//                             const months = this.getAllMonthsForYearRange();
//                             if (months.length === 0) {
//                                  console.warn("Filter Label Click: Cannot determine year range months.");
//                                  return; // Safety check
//                             }
//                             this.prepareAndOpenModal(orgName, months, 'year'); // Specify 'year' context
//                         }
                      
//                         // --- Helper to get all month strings for the year range ---
//                         getAllMonthsForYearRange(): string[] {
//                             const { start, end } = this.calculateDateRangeForYear();
//                             const startDate = new Date(start + 'T00:00:00');
//                             const endDate = new Date(end + 'T00:00:00');
//                             const months: string[] = [];
//                             let currentDate = startDate;
                      
//                             while (currentDate <= endDate) {
//                                 const y = currentDate.getFullYear();
//                                 const m = (currentDate.getMonth() + 1).toString().padStart(2, '0');
//                                 months.push(`${y}-${m}`);
//                                 // Move to the first day of the next month to avoid issues with varying day counts
//                                 currentDate.setMonth(currentDate.getMonth() + 1, 1);
//                             }
//                             return months;
//                         }
                      
                      
//                         // --- Common function to prepare data and open modal ---
//                         prepareAndOpenModal(orgName: string, months: string[], context: 'month' | 'year'): void {
//                             // Filter raw data for the given org and *all* specified months
//                             const filteredRawData = this.lastRawData.filter(item =>
//                                 item.organization === orgName && months.includes(item.time_group)
//                             );
                      
//                             if (filteredRawData.length === 0) {
//                                 console.log(`Modal Prep: No raw data found for ${orgName} in months: ${months.join(', ')}`);
//                                 // Inform user, maybe modal isn't needed or expected?
//                                 // Example: alert(`Brak danych dla ${orgName} w tym okresie.`);
//                                 return; // Don't open modal if no relevant raw data
//                             }
                      
//                             // Aggregate campaign minutes across the selected months
//                             const campaignMinutes = new Map<string, number>();
//                             filteredRawData.forEach(item => {
//                                 const currentMinutes = campaignMinutes.get(item.campaign_name) || 0;
//                                 campaignMinutes.set(item.campaign_name, currentMinutes + (Number(item.total_minutes) || 0));
//                             });
                      
//                             // Convert aggregated data to the format expected by the modal
//                             const drillDownDetails = Array.from(campaignMinutes.entries())
//                                 .map(([campaign_name, total_minutes]) => ({ campaign_name, total_minutes }))
//                                 .sort((a, b) => b.total_minutes - a.total_minutes); // Sort descending
                      
//                             console.log(`Modal Prep: Aggregated data for ${orgName} (${months.length} months):`, drillDownDetails);
                      
//                             // Determine the title label for the period
//                             let periodLabel = '';
//                             if (context === 'month' && months.length === 1) {
//                                 periodLabel = months[0]; // Single month from cell click
//                             } else if (context === 'year') {
//                                 periodLabel = "Ostatni rok"; // Label for filter click (whole year)
//                             } else if (months.length > 1) {
//                                  // Fallback for multi-month context if needed (e.g. from cell click if logic changes)
//                                  const sorted = [...months].sort();
//                                  periodLabel = `Okres: ${sorted[0]} - ${sorted[sorted.length - 1]}`;
//                             }
//                              else {
//                                 periodLabel = "Wybrany okres"; // Generic fallback
//                             }
                      
                      
//                             // Check if aggregation resulted in any details to show
//                             if (drillDownDetails.length === 0) {
//                                 console.log(`Modal Prep: No aggregated campaign data found for ${orgName} in ${periodLabel}. Modal not opened.`);
//                                  // Example: alert(`Brak szczegółowych danych o kampaniach dla ${orgName} w okresie ${periodLabel}.`);
//                                 return; // Don't open modal if nothing to show after aggregation
//                             }
                      
//                             this.openDrillDownModal(orgName, periodLabel, drillDownDetails);
//                         }
                      
//                         // --- Modal Opening Function ---
//                         openDrillDownModal(
//                           orgName: string,
//                           periodLabel: string,
//                           details: { campaign_name: string, total_minutes: number }[]
//                         ): void {
//                           // Disable hover effect on org spans when modal opens
//                           const spans = document.querySelectorAll('.clickable-org-span');
//                           spans.forEach(span => span.classList.add('no-hover'));
                        
//                           this.modalRef?.close();
                        
//                           this.modalRef = this.modalService.open(DrilldownModalComponent, {
//                             ariaLabelledBy: 'modal-basic-title',
//                             size: 'lg',
//                             scrollable: true,
//                             centered: true
//                           });
                        
//                           this.modalRef.componentInstance.organizationName = orgName;
//                           this.modalRef.componentInstance.month = periodLabel;
//                           this.modalRef.componentInstance.drillDownData = details;
                        
//                           this.modalRef.result.then(
//                             (result) => { console.log(`Modal closed with: ${result}`); },
//                             (reason) => { console.log(`Modal dismissed with reason: ${reason}`); }
//                           ).finally(() => {
//                             // Re-enable hover effect after modal closes
//                             spans.forEach(span => span.classList.remove('no-hover'));
//                             this.modalRef = undefined;
//                           });
//                         }
                        
                      
//                         // --- Utility Functions ---
//                         calculateDateRangeForYear() {
//                             const today = new Date();
//                             const start = new Date(today.getFullYear(), today.getMonth() - 11, 1); // 1st day of 11 months ago
//                             const end = new Date(today.getFullYear(), today.getMonth() + 1, 0); // Last day of current month
//                             return { start: this.formatDate(start), end: this.formatDate(end) };
//                         }
                      
//                         formatDate(date: Date): string {
//                             const y = date.getFullYear();
//                             const m = (date.getMonth() + 1).toString().padStart(2, '0');
//                             const d = date.getDate().toString().padStart(2, '0');
//                             return `${y}-${m}-${d}`;
//                         }
                      
//                       } // End of StatisticsHeatmapComponent class

//                       // dodanie drugiej heatmap


import {
    Component,
    ViewChild,
    OnDestroy,
    OnInit,
    ChangeDetectorRef,
    Injectable
} from '@angular/core';
import { Subscription, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DrilldownModalComponent } from '../statistics-chart/drilldown-modal/drilldown-modal.component';
import {
    ApexChart,
    ApexAxisChartSeries,
    ApexDataLabels,
    ApexPlotOptions,
    ApexYAxis,
    ApexLegend,
    ApexStroke,
    ApexXAxis,
    ApexTooltip,
    ApexStates,
    ApexNonAxisChartSeries,
    ApexResponsive,
    ChartComponent,
    ApexTitleSubtitle
} from 'ng-apexcharts';
import { TranslateService } from '@ngx-translate/core';

// --- Interfaces ---
export interface StatisticData {
    campaign_uuid: string;
    campaign_name: string;
    organization: string;
    time_group: string; // Format: "YYYY-MM"
    total_minutes: number;
    total_duration: number; // Added for second heatmap
}

export interface ApiResponse {
    message: string;
    data: StatisticData[];
    error: string | null;
}

// --- Service Definition ---
@Injectable({ providedIn: 'root' })
export class StatisticsService {
    private apiUrl = `${environment.apiUri}/statistics/organisations`;
    constructor(private http: HttpClient) { }

    getStatistics(start: string, end: string, groupby: string): Observable<ApiResponse> {
        console.log(`Heatmap Proxy Call: Fetching stats from ${start} to ${end} grouped by ${groupby} via ${this.apiUrl}`);
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Accept': 'application/json' });
        const body = { start, end, groupby };
        return this.http.post<ApiResponse>(this.apiUrl, body, { headers: headers })
            .pipe(
                catchError(error => {
                    console.error('Heatmap Proxy API Error:', error);
                    const errorResponse: ApiResponse = {
                        message: error.error?.message || 'Failed to fetch heatmap statistics', data: [],
                        error: error.error?.error || error.message || 'Unknown proxy error'
                    };
                    return of(errorResponse);
                })
            );
    }
}

// --- ChartOptions Type Definition ---
export type HeatmapChartOptions = {
    series: ApexAxisChartSeries | ApexNonAxisChartSeries;
    chart: ApexChart;
    xaxis: ApexXAxis;
    stroke: ApexStroke;
    dataLabels: ApexDataLabels;
    plotOptions: ApexPlotOptions;
    yaxis: ApexYAxis;
    tooltip: ApexTooltip;
    legend?: ApexLegend;
    states?: ApexStates;
    responsive?: ApexResponsive[];
    title?: ApexTitleSubtitle;
};

// --- Component Definition ---
@Component({
    selector: 'app-statistics-heatmap',
    templateUrl: './statistics-heatmap.component.html',
    styleUrls: ['./statistics-heatmap.component.scss'],
})
export class StatisticsHeatmapComponent implements OnInit, OnDestroy {
    // --- Properties for Heatmap Charts ---
    @ViewChild('heatmapChart') private heatmapChartComponent!: ChartComponent;
    public heatmapOptions!: Partial<HeatmapChartOptions>;
    @ViewChild('heatmapChartDuration') private heatmapChartComponentDuration!: ChartComponent;
    public heatmapOptionsDuration!: Partial<HeatmapChartOptions>;
    public isLoading: boolean = false;
    public errorMessage: string | null = null;
    public totalMinutesPerMonth: { [month: string]: number } = {};
    public totalDurationPerMonth: { [month: string]: number } = {};

    // --- Properties for Filters ---
    public isCollapsed: boolean = true;
    public allOrganizations: string[] = [];
    public selectedOrganizations: { [orgName: string]: boolean } = {};
    public initialOrgLoadComplete: boolean = false;

    // --- Data Properties ---
    private dataSubscription: Subscription | undefined;
    public lastRawData: StatisticData[] = [];

    // --- Modal Properties ---
    private modalRef: NgbModalRef | undefined;

    constructor(
        private statisticsService: StatisticsService,
        private cdRef: ChangeDetectorRef,
        private modalService: NgbModal,
        public translate: TranslateService
    ) {
        this.initializeHeatmapOptions();
        this.initializeHeatmapOptionsDuration();
    }

    ngOnInit() {
        this.loadHeatmapData();
    }

    ngOnDestroy() {
        this.dataSubscription?.unsubscribe();
        this.modalRef?.close();
    }

    // --- Data Fetching ---
    loadHeatmapData() {
        const { start, end } = this.calculateDateRangeForYear();
        console.log(`🔥 Heatmap: Fetching data for year: ${start} to ${end}`);
        this.isLoading = true;
        this.errorMessage = null;
        this.dataSubscription?.unsubscribe();

        this.dataSubscription = this.statisticsService
            .getStatistics(start, end, 'month')
            .subscribe({
                next: (response) => {
                    console.log('✅ Heatmap API response received');
                    this.isLoading = false;

                    if (response.error) {
                        this.errorMessage = response.message || response.error || 'Unknown error from API';
                        this.lastRawData = [];
                    } else {
                        this.errorMessage = null;
                        this.lastRawData = response.data || [];
                        console.log('📦 Heatmap Data loaded:', this.lastRawData.length);
                    }

                    if (!this.initialOrgLoadComplete) {
                        if (this.lastRawData.length > 0) {
                            this.populateInitialOrganizations(this.lastRawData);
                        } else {
                            this.allOrganizations = [];
                            this.selectedOrganizations = {};
                        }
                        this.initialOrgLoadComplete = true;
                    }

                    setTimeout(() => {
                        this.processAndDisplayHeatmap(this.lastRawData);
                        this.cdRef.detectChanges();
                    }, 0);
                },
                error: (err) => {
                    console.error('❌ Heatmap HTTP call failed:', err);
                    this.errorMessage = 'Failed to connect to the backend service.';
                    this.lastRawData = [];
                    if (!this.initialOrgLoadComplete) {
                        this.allOrganizations = [];
                        this.selectedOrganizations = {};
                        this.initialOrgLoadComplete = true;
                    }
                    this.isLoading = false;
                    this.processAndDisplayHeatmap([]);
                    this.cdRef.detectChanges();
                },
                complete: () => {
                    console.log('📍 Heatmap Observable complete');
                }
            });
    }

    // --- Filter Initialization ---
    populateInitialOrganizations(data: StatisticData[]) {
        const orgSet = new Set<string>(data.map((d) => d.organization));
        this.allOrganizations = Array.from(orgSet).sort((a, b) => a.localeCompare(b));
        const previousSelection = { ...this.selectedOrganizations };
        this.selectedOrganizations = {};
        this.allOrganizations.forEach((org) => {
            this.selectedOrganizations[org] = previousSelection[org] ?? true;
        });
    }

    // --- Heatmap Initialization ---
    initializeHeatmapOptions(): void {
        this.heatmapOptions = {
            series: [],
            chart: {
                type: 'heatmap',
                height: 450,
                toolbar: { show: true },
                events: {
                    dataPointSelection: (event, chartContext, config) => {
                        this.handleHeatmapDataPointClick(config.seriesIndex, config.dataPointIndex, chartContext, 'minutes');
                    },
                    dataPointMouseEnter: (event: any) => {
                        if (event.target) {
                            (event.target as HTMLElement).style.cursor = 'pointer';
                        }
                    },
                    dataPointMouseLeave: (event: any) => {
                        if (event.target) {
                            (event.target as HTMLElement).style.cursor = 'default';
                        }
                    }
                }
            },
            plotOptions: {
                heatmap: {
                    shadeIntensity: 0.6,
                    radius: 2,
                    useFillColorAsStroke: false,
                    enableShades: true,
                    colorScale: {
                        ranges: [
                            { from: 0, to: 0.99, name: '0', color: '#EEEEEE' },
                            { from: 1, to: 60, name: '1–60 min', color: '#AED9E0' },
                            { from: 61, to: 300, name: '61–300 min', color: '#75B3FF' },
                            { from: 301, to: 1000, name: '301–1k min', color: '#FFC300' },
                            { from: 1001, to: 3000, name: '1k–3k min', color: '#FFAA00' },
                            { from: 3001, to: 9000, name: '3k–9k min', color: '#FF6600' },
                            { from: 9001, to: 15000, name: '9k–15k min', color: '#FF0000' },
                            { from: 15001, to: 20000, name: '15k–20k min', color: '#C70039' },
                            { from: 20001, to: 25000, name: '20k–25k min', color: '#900C3F' },
                            { from: 25001, to: 30000, name: '25k–30k min', color: '#581845' }
                        ]
                    }                    
                }
            },
            dataLabels: {
                enabled: true,
                formatter: (val) => {
                    const numVal = Number(val);
                    return !isNaN(numVal) && numVal > 0 ? Math.round(numVal).toString() : '';
                }
            },
            stroke: { width: 1, colors: ['#FFFFFF'] },
            xaxis: {
                type: 'category',
                position: 'top',
                tooltip: { enabled: false },
                labels: {
                    rotate: -45,
                    style: {
                        fontSize: '11px',
                        whiteSpace: 'pre'
                    },
                    formatter: (value: string) => {
                        const total = this.totalMinutesPerMonth?.[value] ?? 0;
                        return `${value} ( ${Math.round(total)} min )`;
                    }
                } as any
            },
            yaxis: { tooltip: { enabled: false }, reversed: false },
            tooltip: {
                y: {
                    formatter: (value) => `${value ? Math.round(value) : '0'} minut`
                }
            },
            title: { },
            legend: { show: true, position: 'bottom', horizontalAlign: 'center' },
            responsive: [
                { breakpoint: 992, options: { chart: { height: 500 } } },
                { breakpoint: 768, options: { chart: { height: 600 }, yaxis: { labels: { minWidth: 80, maxWidth: 100 } } } },
                { breakpoint: 576, options: { chart: { height: 450 }, yaxis: { labels: { show: false } } } }
            ]
        };
        console.log('🔥 Heatmap options initialized for total_minutes.');
    }

    initializeHeatmapOptionsDuration(): void {
        this.heatmapOptionsDuration = {
            series: [],
            chart: {
                type: 'heatmap',
                height: 450,
                toolbar: { show: true },
                events: {
                    dataPointSelection: (event, chartContext, config) => {
                        this.handleHeatmapDataPointClick(config.seriesIndex, config.dataPointIndex, chartContext, 'duration');
                    },
                    dataPointMouseEnter: (event: any) => {
                        if (event.target) {
                            (event.target as HTMLElement).style.cursor = 'pointer';
                        }
                    },
                    dataPointMouseLeave: (event: any) => {
                        if (event.target) {
                            (event.target as HTMLElement).style.cursor = 'default';
                        }
                    }
                }
            },
            plotOptions: {
                heatmap: {
                    shadeIntensity: 0.6,
                    radius: 2,
                    useFillColorAsStroke: false,
                    enableShades: true,
                    colorScale: {
                        ranges: [
                            { from: 0, to: 0.99, name: '0', color: '#EEEEEE' },
                            { from: 1, to: 600, name: '1–600 min', color: '#AED9E0' },
                            { from: 601, to: 3000, name: '601–3k min', color: '#75B3FF' },
                            { from: 3001, to: 6000, name: '3k–6k min', color: '#FFC300' },
                            { from: 6001, to: 9000, name: '6k–9k min', color: '#FF6600' },
                            { from: 9001, to: 13000, name: '9k–13k min', color: '#FF0000' },
                            { from: 13001, to: 20000, name: '13k–20k min', color: '#C70039' },
                            { from: 20001, to: 25000, name: '20k–25k min', color: '#900C3F' },
                            { from: 25001, to: 30000, name: '25k–30k min', color: '#581845' }
                        ]
                    }                    
                }
            },
            dataLabels: {
                enabled: true,
                formatter: (val) => {
                    const numVal = Number(val);
                    return !isNaN(numVal) && numVal > 0 ? Math.round(numVal).toString() : '';
                }
            },
            stroke: { width: 1, colors: ['#FFFFFF'] },
            xaxis: {
                type: 'category',
                position: 'top',
                tooltip: { enabled: false },
                labels: {
                    rotate: -45,
                    style: {
                        fontSize: '11px',
                        whiteSpace: 'pre'
                    },
                    formatter: (value: string) => {
                        const total = this.totalDurationPerMonth?.[value] ?? 0;
                        return `${value} ( ${Math.round(total)} min )`;
                    }
                } as any
            },
            yaxis: { tooltip: { enabled: false }, reversed: false },
            tooltip: {
                y: {
                    formatter: (value) => `${value ? Math.round(value) : '0'} minut`
                }
            },
            title: { },
            legend: { show: true, position: 'bottom', horizontalAlign: 'center' },
            responsive: [
                { breakpoint: 992, options: { chart: { height: 500 } } },
                { breakpoint: 768, options: { chart: { height: 600 }, yaxis: { labels: { minWidth: 80, maxWidth: 100 } } } },
                { breakpoint: 576, options: { chart: { height: 450 }, yaxis: { labels: { show: false } } } }
            ]
        };
        console.log('🔥 Heatmap options initialized for total_duration.');
    }

    // --- Heatmap Data Processing ---
    processAndDisplayHeatmap(rawData: StatisticData[]) {
        console.log('🔥 Przetwarzanie danych dla obu map cieplnych...');

        if (!this.initialOrgLoadComplete) {
            console.log("⏳ Heatmap: Czekanie na zakończenie ładowania organizacji...");
            return;
        }

        const activeOrganizations = Object.entries(this.selectedOrganizations)
            .filter(([, isSelected]) => isSelected)
            .map(([orgName]) => orgName);

        const filteredData = rawData.filter(item => activeOrganizations.includes(item.organization));

        const monthSet = new Set<string>(filteredData.map((d) => d.time_group));
        const sortedMonths = Array.from(monthSet).sort();

        const orgSet = new Set<string>(filteredData.map(d => d.organization));
        const sortedOrgs = Array.from(orgSet).sort((a, b) => a.localeCompare(b));

        // --- Przetwarzanie dla pierwszej mapy cieplnej (total_minutes) ---
        let heatmapMinutes: ApexAxisChartSeries = [];
        this.totalMinutesPerMonth = {};
        sortedMonths.forEach(month => this.totalMinutesPerMonth[month] = 0);

        // --- Przetwarzanie dla drugiej mapy cieplnej (total_duration) ---
        let heatmapDuration: ApexAxisChartSeries = [];
        this.totalDurationPerMonth = {};
        sortedMonths.forEach(month => this.totalDurationPerMonth[month] = 0);

        if (filteredData.length > 0) {
            const dataMapMinutes = new Map<string, Map<string, number>>();
            const dataMapDuration = new Map<string, Map<string, number>>();

            filteredData.forEach((item) => {
                const org = item.organization;
                const month = item.time_group;
                const minutes = Number(item.total_minutes) || 0;
                const duration = Number(item.total_duration) || 0;

                // Minutes
                if (!dataMapMinutes.has(org)) {
                    dataMapMinutes.set(org, new Map());
                }
                const orgMonthMapMinutes = dataMapMinutes.get(org)!;
                const currentMinutes = orgMonthMapMinutes.get(month) || 0;
                orgMonthMapMinutes.set(month, currentMinutes + minutes);
                this.totalMinutesPerMonth[month] += minutes;

                // Duration
                if (!dataMapDuration.has(org)) {
                    dataMapDuration.set(org, new Map());
                }
                const orgMonthMapDuration = dataMapDuration.get(org)!;
                const currentDuration = orgMonthMapDuration.get(month) || 0;
                orgMonthMapDuration.set(month, currentDuration + duration);
                this.totalDurationPerMonth[month] += duration;
            });

            // Series for Minutes
            heatmapMinutes = sortedOrgs.map(orgName => {
                const orgDataMap = dataMapMinutes.get(orgName) || new Map();
                return {
                    name: orgName,
                    data: sortedMonths.map(month => ({
                        x: month,
                        y: orgDataMap.get(month) || 0
                    }))
                };
            });

            // Series for Duration
            heatmapDuration = sortedOrgs.map(orgName => {
                const orgDataMap = dataMapDuration.get(orgName) || new Map();
                return {
                    name: orgName,
                    data: sortedMonths.map(month => ({
                        x: month,
                        y: orgDataMap.get(month) || 0
                    }))
                };
            });

            console.log('🔥 Seria dla pierwszej heatmap (total_minutes):', heatmapMinutes);
            console.log('🔥 Seria dla drugiej heatmap (total_duration):', heatmapDuration);
            console.log('📅 Miesiące (xaxis):', sortedMonths);
            console.log('📊 Sumy minut:', this.totalMinutesPerMonth);
            console.log('📊 Sumy czasu trwania:', this.totalDurationPerMonth);
        } else {
            console.log('🔥 Heatmap: Brak danych po filtrowaniu.');
        }

        this.updateHeatmap(sortedMonths, heatmapMinutes);
        this.updateHeatmapDuration(sortedMonths, heatmapDuration);
    }

    // --- Heatmap Update Functions ---
    updateHeatmap(categories: string[], series: ApexAxisChartSeries) {
        this.heatmapOptions = {
            ...this.heatmapOptions,
            series: series,
            xaxis: {
                ...this.heatmapOptions.xaxis,
                categories: categories,
            },
            yaxis: { ...this.heatmapOptions.yaxis },
            plotOptions: { ...this.heatmapOptions.plotOptions }
        };
        this.heatmapChartComponent?.updateOptions(this.heatmapOptions).catch(err => console.error("🔥 Błąd aktualizacji heatmap:", err));
        console.log('🔥 Pierwsza Heatmap zaktualizowana.');
    }

    updateHeatmapDuration(categories: string[], series: ApexAxisChartSeries) {
        this.heatmapOptionsDuration = {
            ...this.heatmapOptionsDuration,
            series: series,
            xaxis: {
                ...this.heatmapOptionsDuration.xaxis,
                categories: categories,
            },
            yaxis: { ...this.heatmapOptionsDuration.yaxis },
            plotOptions: { ...this.heatmapOptionsDuration.plotOptions }
        };
        this.heatmapChartComponentDuration?.updateOptions(this.heatmapOptionsDuration).catch(err => console.error("🔥 Błąd aktualizacji heatmap Duration:", err));
        console.log('🔥 Druga Heatmap zaktualizowana.');
    }

    // --- Event Handlers for Filters ---
    selectAllOrgs(): void {
        if (this.isLoading || !this.allOrganizations) return;
        this.allOrganizations.forEach(org => { this.selectedOrganizations[org] = true; });
        this.onOrganizationSelectionChange();
    }

    deselectAllOrgs(): void {
        if (this.isLoading || !this.allOrganizations) return;
        this.allOrganizations.forEach(org => { this.selectedOrganizations[org] = false; });
        this.onOrganizationSelectionChange();
    }

    onOrganizationSelectionChange(): void {
        if (this.isLoading) return;
        console.log('👥 Heatmap: Zmiana wyboru organizacji:', this.selectedOrganizations);
        this.processAndDisplayHeatmap(this.lastRawData);
    }

    // --- Click Handler for Heatmap Cells ---
    handleHeatmapDataPointClick(seriesIndex: number, dataPointIndex: number, chartContext: any, timeType: 'minutes' | 'duration'): void {
        let selectedOrg: string = '';
        let selectedMonth: string = '';
        try {
            const w = chartContext.w;
            selectedOrg = w.globals.seriesNames[seriesIndex] ?? 'Nieznana organizacja';
            selectedMonth = w.globals.labels[dataPointIndex] ?? 'Nieznany miesiąc';
        } catch (e) {
            console.error("Błąd podczas wyodrębniania danych z kliknięcia heatmap:", e);
            this.errorMessage = this.translate.instant("HEATMAP.ERROR.POINT_READ_FAIL");
            this.cdRef.detectChanges();
            return;
        }

        console.log(`🖱️ Heatmap Cell Drilldown dla Org: ${selectedOrg}, Month: ${selectedMonth}, Type: ${timeType}`);
        this.prepareAndOpenModal(selectedOrg, [selectedMonth], 'month', timeType);
    }

    // --- Click Handler for Filter Labels ---
    handleFilterLabelClick(orgName: string): void {
        console.log(`🖱️ Heatmap Filter Label Drilldown dla Org: ${orgName}`);
        const months = this.getAllMonthsForYearRange();
        if (months.length === 0) {
            console.warn("Filter Label Kliknięcie: Nie można określić miesięcy dla zakresu roku.");
            return;
        }
        this.prepareAndOpenModal(orgName, months, 'year', 'minutes');
    }

    // --- Helper to get all month strings ---
    getAllMonthsForYearRange(): string[] {
        const { start, end } = this.calculateDateRangeForYear();
        const startDate = new Date(start + 'T00:00:00');
        const endDate = new Date(end + 'T00:00:00');
        const months: string[] = [];
        let currentDate = startDate;

        while (currentDate <= endDate) {
            const y = currentDate.getFullYear();
            const m = (currentDate.getMonth() + 1).toString().padStart(2, '0');
            months.push(`${y}-${m}`);
            currentDate.setMonth(currentDate.getMonth() + 1, 1);
        }
        return months;
    }

    // --- Modal Preparation ---
    prepareAndOpenModal(orgName: string, months: string[], context: 'month' | 'year', timeType: 'minutes' | 'duration'): void {
        const filteredRawData = this.lastRawData.filter(item =>
            item.organization === orgName && months.includes(item.time_group)
        );

        if (filteredRawData.length === 0) {
            console.log(`🔴 Modal Prep: Brak danych dla ${orgName} w ${months.join(', ')}`);
            return;
        }

        const campaignTotals = new Map<string, number>();
        filteredRawData.forEach(item => {
            const currentTotal = campaignTotals.get(item.campaign_name) || 0;
            const value = timeType === 'minutes' ? Number(item.total_minutes) : Number(item.total_duration);
            campaignTotals.set(item.campaign_name, currentTotal + (value || 0));
        });

        const drillDownDetails = Array.from(campaignTotals.entries())
            .map(([campaign_name, total]) => ({ campaign_name, total_minutes: total }))
            .sort((a, b) => b.total_minutes - a.total_minutes);

        console.log(`🔵 Modal Prep: Agregowane dane dla ${orgName} (${months.length} miesięcy, ${timeType}):`, drillDownDetails);

        let periodLabel = '';
        if (context === 'month' && months.length === 1) {
    periodLabel = this.translate.instant("HEATMAP.MODAL.PERIOD.SINGLE", { month: months[0] });
} else if (context === 'year') {
    periodLabel = this.translate.instant("HEATMAP.MODAL.PERIOD.LAST_YEAR");
} else if (months.length > 1) {
    const sorted = [...months].sort();
    periodLabel = this.translate.instant("HEATMAP.MODAL.PERIOD.RANGE", {
        start: sorted[0],
        end: sorted[sorted.length - 1]
    });
} else {
    periodLabel = this.translate.instant("HEATMAP.MODAL.PERIOD.DEFAULT");
}


        if (drillDownDetails.length === 0) {
            console.log(`🔴 Modal Prep: Brak danych kampanii dla ${orgName} w ${periodLabel}.`);
            return;
        }

        this.openDrillDownModal(orgName, periodLabel, drillDownDetails);
    }

    // --- Modal Opening ---
    openDrillDownModal(orgName: string, periodLabel: string, details: { campaign_name: string, total_minutes: number }[]): void {
        const spans = document.querySelectorAll('.clickable-org-span');
        spans.forEach(span => span.classList.add('no-hover'));

        this.modalRef?.close();

        this.modalRef = this.modalService.open(DrilldownModalComponent, {
            ariaLabelledBy: 'modal-basic-title',
            size: 'lg',
            scrollable: true,
            centered: true
        });

        // Set modal inputs
        this.modalRef.componentInstance.organizationName = orgName;
        this.modalRef.componentInstance.month = periodLabel;
        this.modalRef.componentInstance.drillDownData = details;

        console.log(`🖱️ Otwieranie modalu dla: ${orgName}, Okres: ${periodLabel}, Dane:`, details);

        this.modalRef.result.then(
            (result) => { console.log(`Modal zamknięto z: ${result}`); },
            (reason) => { console.log(`Modal odrzucono z: ${reason}`); }
        ).finally(() => {
            spans.forEach(span => span.classList.remove('no-hover'));
            this.modalRef = undefined;
        });
    }

    // --- Utility Functions ---
    calculateDateRangeForYear() {
        const today = new Date();
        const start = new Date(today.getFullYear(), today.getMonth() - 11, 1);
        const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        return { start: this.formatDate(start), end: this.formatDate(end) };
    }

    formatDate(date: Date): string {
        const y = date.getFullYear();
        const m = (date.getMonth() + 1).toString().padStart(2, '0');
        const d = date.getDate().toString().padStart(2, '0');
        return `${y}-${m}-${d}`;
    }
}